import { useDispatch } from 'react-redux';
import { FormInput } from '../../commons/forms/FormInput';
import { useAppSelector } from '../../redux/store';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import { logout } from '../../redux/slices/appStateSlice';
import CustomCard from '../../commons/layout/CustomCard';
import "./account.css";

export default function Account() {
    const user = useAppSelector(state => state.appState.user);
    const dispatch = useDispatch();
    return (
        <CustomCard>
            <Form
                initialValues={{
                    user: user
                }}
                render={() => (
                    <FormElement className="account-form">
                        <fieldset className={'k-form-fieldset'}>
                            <Field
                                disabled
                                value={user}
                                id={'user'}
                                name={'user'}
                                label={'Utilisateur'}
                                component={FormInput}
                            />
                            <div className="k-form-buttons">
                                <Button icon={'logout'} onClick={() => dispatch(logout())}>
                                    Déconnexion
                                </Button>
                            </div>
                        </fieldset>
                    </FormElement>
                )}
            />
        </CustomCard>
    );
}
